import { defineMessages } from 'react-intl';

export default defineMessages({
  ftuCarriersStepTitle: {
    description: 'Title for the carriers step in the FTU wizard',
    defaultMessage: 'ShipStation offers discounted rates from the most popular carriers.',
    id: 'QiOB08',
  },
  ftuCarriersStepDescription: {
    description: 'Description for the carriers step in the FTU wizard',
    defaultMessage: 'Services from these carriers are available to compare rates and ship with right away.',
    id: '8aUHiU',
  },
  setupPayment: {
    description: 'Button text to setup payment for carriers',
    defaultMessage: 'Set Up Payment',
    id: '1OUcZe',
  },
  savingUpPercentageMessage: {
    description: 'Message about saving up with discounted rates',
    defaultMessage: 'Start saving up to 89% off retail rates. Set up a payment method to activate all carriers.',
    id: 'Ib7f71',
  },
  savingUpMessage: {
    description: 'Message about saving up with discounted rates',
    defaultMessage: 'Start saving on retail rates. Set up a payment method to activate all carriers.',
    id: 'Xft+Es',
  },
  successMessage: {
    description: 'Success message after payment is added',
    defaultMessage: "You're all set! Payment added – now you can start saving with discounted shipping labels.",
    id: 'c2cjcu',
  },
  editButton: {
    description: 'Edit button text',
    defaultMessage: 'Edit',
    id: 'hcDY47',
  },
  typeLabel: {
    description: 'Type label',
    defaultMessage: 'Type',
    id: 'qBKOEO',
  },
  creditCard: {
    description: 'Credit Card payment method',
    defaultMessage: 'Credit Card',
    id: 'IF5D6o',
  },
  paypal: {
    description: 'PayPal payment method',
    defaultMessage: 'PayPal',
    id: 'HdMAzp',
  },
  ach: {
    description: 'ACH payment method',
    defaultMessage: 'ACH',
    id: 'ACS3J0',
  },
  adyenCreditCard: {
    description: 'Adyen Credit Card payment method',
    defaultMessage: 'Adyen Credit Card',
    id: 'nCvNH7',
  },
  logoAlt: {
    description: 'Alt text for the logo image',
    defaultMessage: 'ShipStation and Carriers',
    id: 'aIs/EU',
  },
  activateCarriersLinkText: {
    description: 'Link text to activate carriers',
    defaultMessage: 'Activate carriers individually',
    id: 'voFZOc',
  },
});
